/** Public catalogue URL. The short `code` is the key; a numeric id still opens the page. */
export function publicPath(
  kind: "songs" | "albums" | "videos" | "artists",
  item: { id: number | string; code?: string | null },
  suffix = "",
): string {
  return `/${kind}/${item.code || item.id}${suffix}`;
}
